/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useEffect, useState } from 'react'
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useBreakpointValue
} from '@chakra-ui/react'
import { LuChevronDown } from 'react-icons/lu'
import Styles from './styles.module.sass'

const FilterList = ({
  filters,
  filterByValue,
  setCurrentId
}) => {
  const [currentFilter, setCurrentFilter] = useState('Filters')
  const currentMenuItems = filters.map((filter, index) => {
    const currentOnClick = () => {
      setCurrentFilter(filter.label)

      filter.action && filter.action()
      setCurrentId && setCurrentId(filter.id)
    }

    return (
      <MenuItem
        key={filter.id}
        onClick={currentOnClick}
        className="text-sm"
      >
        { filter.label }
      </MenuItem>
    )
  })

  const textClass = useBreakpointValue({
    base: Styles.buttonContentSize,
    md: ''
  })

  useEffect(() => {
    if (filterByValue) {
      const selectedFilter = filters.find(
        filter => filter.id === filterByValue
      )
      setCurrentFilter(
        selectedFilter
          ? selectedFilter.label
          : 'Filters'
      )
    } else {
      setCurrentFilter('Filters')
    }
  }, [filterByValue, filters])

  return (
    <Menu>
      <MenuButton
        transition='all 0.2s'
        borderWidth='0px'
        _hover={{ bg: 'trasparent' }}
        _expanded={{ bg: 'trasparent' }}
        _focus={{ boxShadow: 'outline' }}
      >
        <div className={`${Styles.buttonContent} ${textClass}`}>
          { currentFilter } <LuChevronDown className="inline" />
        </div>
      </MenuButton>
      <MenuList>
        { currentMenuItems }
      </MenuList>
    </Menu>
  )
}

export default FilterList
